export default __webpack_public_path__ + "static/media/banner4.17baf1dc.jpg";